import type { Patient, Reference } from "@medplum/fhirtypes";
import { PATIENT_ENTITY_ID_SYSTEM } from "@repo/api";

export const PATIENT_COLLECTION = "patient";

/** Domain identity carried by a Patient reference, without locator translation. */
export function patientDomainId(reference: Reference | undefined): string {
  if (reference?.identifier?.system === PATIENT_ENTITY_ID_SYSTEM && reference.identifier.value) {
    return reference.identifier.value;
  }
  return "";
}

/** Identifier-only reference for optimistic rows whose FHIR locator is not available client-side. */
export function optimisticPatientReference(patientId: string): Reference<Patient> {
  return { identifier: { system: PATIENT_ENTITY_ID_SYSTEM, value: patientId } };
}
